export enum LocalStorageType {
  LocalStorage,
  SessionStorage
}
